/**
 * 分类页 Tab：productnature 与展示名称
 * 0=全部, 1=耗材(01), 2=设备(02), 3=检验(03), 4=其他(04)
 */
export const CLASSIFY_NATURE_LIST = [
	{ label: '全部', productnature: null as string | null },
	{ label: '耗材', productnature: '01' },
	{ label: '设备', productnature: '02' },
	{ label: '检验', productnature: '03' },
	{ label: '其他', productnature: '04' },
];

/** Tab 索引对应的 productnature */
export const NATURE_MAP = CLASSIFY_NATURE_LIST.map(item => item.productnature);

/** productnature 码 → Tab 索引（仅含 01/02/03/04，不含全部） */
const _indexEntries = CLASSIFY_NATURE_LIST.map((item, index) => [item.productnature, index] as const).filter(([code]) => code != null);
export const NATURE_INDEX: Record<string, number> = Object.fromEntries(_indexEntries);

/** Tab 展示文案列表 */
export const TABS = CLASSIFY_NATURE_LIST.map(item => item.label);

/** 根据 productnature 码取分类名（用于 TDK 等） */
export function getCategoryLabel(productnature: string | null | undefined): string {
	if (!productnature) return '全部';
	const item = CLASSIFY_NATURE_LIST.find(x => x.productnature === productnature);
	return item?.label ?? '商品';
}
